var _defs, _path, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBudget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.69 56.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 1.8px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke: #1d47b1;\n        stroke-linecap: round;\n      }\n\n      .cls-4 {\n        fill: #d7e8f0;\n        stroke: #d7e8f0;\n      }\n\n      .cls-4, .cls-3 {\n        stroke-width: 2px;\n      }\n\n      .cls-3 {\n        stroke-linejoin: round;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.1,13.23c5.1-5.63,14.66-4.08,16.34,5.1,1.68,9.19-6.27,11.21-8.23,14.58-2.74,4.72-1.29,13.21-10.23,13.81-9.13,.61-6.4-10.32-13.9-10.16-25.13,.53-16.57-27.31-2.67-24.27,6.79,1.48,12.6,7.66,18.69,.94Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.59,10.86V45.83H47.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.4,19.39l-15.47,14.85-8.14-7.82-12.21,11.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.17,19.39h10.23v9.38"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 56.69,
    height: 56.69
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/budget.b709cabb9aba2d9b2c3af080fa823289.svg";
export { ForwardRef as ReactComponent };